var _g, _g2, _g3, _g4, _g5, _path, _g6, _g7, _g8, _path2, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _path3, _g21, _path4, _g22, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 211,
    height: 282,
    viewBox: "0 0 211 282",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_6263_1301)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 105.459,
    cy: 251.309,
    rx: 78.5688,
    ry: 4.69154,
    fill: "#B76A69"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_6263_1301)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.422 249.226C148.422 251.892 150.572 253.463 111.731 253.463C76.1406 253.463 66.2043 248.592 66.2043 247.18C66.2043 242.875 68.6962 244.115 119.757 244.115C155.048 244.115 148.422 246.56 148.422 249.226Z",
    fill: "#A06766"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_6263_1301)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.8811 245.099C99.7926 245.597 95.4254 248.834 86.2066 248.065C75.4226 246.967 75.7346 245.213 75.823 244.716C75.9115 244.219 76.04 244.228 88.9938 244.382C97.7272 244.485 99.9695 244.602 99.8811 245.099Z",
    fill: "#3C0102"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_6263_1301)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.468 247.95C144.303 248.878 143.116 247.915 139.229 247.817C124.117 250.462 122.057 246.261 122.222 245.333C122.387 244.405 122.591 242.887 138.468 244.308C147.814 245.145 144.633 247.022 144.468 247.95Z",
    fill: "#521515"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_ii_6263_1301)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.0549 159.329C-21.7437 137.71 30.7114 92.9667 31.0606 89.5508C80.225 106.239 145.556 143.289 157.45 135.581C157.693 132.456 158.325 131.449 158.91 152.42C159.641 178.633 150.504 228.279 150.139 234.634C149.773 240.989 133.327 253.301 120.171 240.591C107.014 227.882 107.014 239.797 96.0506 244.166C85.0868 248.535 77.074 246.772 67.9937 231.59C58.9135 216.409 70.8071 162.473 59.0549 159.329Z",
    fill: "#D3312F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6263_1301",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 95,
    width: 145,
    height: 152
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.8512 159.264C-13.2898 140.321 24.5544 99.1913 24.9037 95.7754C74.0681 112.464 145.556 143.288 157.451 135.58C157.693 132.455 158.325 131.448 158.91 152.419C159.641 178.632 150.504 228.278 150.139 234.633C149.773 240.988 133.328 253.3 120.171 240.59C107.015 227.881 107.015 239.796 96.0507 244.165C85.0869 248.534 77.0741 246.771 67.9938 231.589C58.9136 216.408 71.0276 162.461 58.8512 159.264Z",
    fill: "#D3312F"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6263_1301)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_6263_1301)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.304 239.845C85.4429 247.796 71.6494 239.182 67.1104 233.881L68.1266 248.901H151.863V235.869C138.367 246.294 123.476 242.863 117.718 239.845H104.304Z",
    fill: "#881718"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_6263_1301)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.8993 160.025C68.8852 151.617 57.8333 154.502 52.4341 156.995L57.9272 165.516C62.3404 167.189 70.9134 168.432 69.8993 160.025Z",
    fill: "#991E1D"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f_6263_1301)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.2869 157.668C59.3969 157.668 57.023 159.089 56.1973 159.799C56.8854 161.706 59.0666 165.071 62.2869 163.276C66.3122 161.033 65.8994 157.668 62.2869 157.668Z",
    fill: "#871514"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter8_f_6263_1301)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.3386 146.686C65.3491 146.658 65.3594 146.628 65.3695 146.595L46.5376 129.68L85.5833 136C103.909 133.887 143.934 130.478 157.428 133.737C174.296 137.81 156.508 142.082 153.188 143.694C147.906 146.259 154.181 152.521 147.726 156.368C141.27 160.215 144.892 144.6 133.011 146.595C121.818 148.475 126.816 160.894 121.818 159.536C116.82 158.179 116.195 156.368 113.072 159.536C109.948 162.705 106.616 168.589 106.824 160.894C107.033 153.2 104.95 143.694 99.5358 153.426C94.1214 163.157 89.1828 160.272 87.874 156.368C83.6249 143.694 81.126 158.305 72.6721 151.163C67.8509 147.09 65.9719 146.572 65.3386 146.686C65.1196 147.268 64.8349 146.777 65.3386 146.686Z",
    fill: "#7C1817"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter9_f_6263_1301)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.3977 147.675C53.1516 144.164 37.4027 125.097 43.205 123.445L154.438 139.241C154.613 140.249 154.857 142.265 154.438 142.265C153.915 142.265 150.699 147.692 148.43 148.641C146.162 149.589 142.41 148.641 138.745 148.641C135.081 148.641 132.276 150.24 129.135 151.732C125.994 153.224 121.618 149.255 119.329 152.891C116.734 157.014 109.516 158.771 109.339 155.1C109.161 151.43 96.3967 146.515 94.2635 148.641C92.1302 150.766 89.6414 153.471 88.397 151.732C87.1526 149.993 85.3749 147.675 84.4861 146.515C83.5972 145.356 77.1345 148.539 72.3977 147.675Z",
    fill: "#631817"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_f_6263_1301)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.271 175.943C148.583 155.035 156.684 151.854 158.749 150.402C158.384 166.637 156.963 201.404 154.194 210.591C150.733 222.074 138.527 226.628 139.62 224.45C140.713 222.272 145.632 202.077 147.271 175.943Z",
    fill: "#C12422"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_f_6263_1301)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.205 157.826C156.595 151.773 162.482 147.352 162.482 152.446C161.468 176.867 155.95 215.135 153.71 216.464C150.909 218.124 152.549 221.125 149.508 216.464C146.168 211.344 151.514 207.983 152.001 203.625C152.488 199.266 152.071 194.287 152.001 189.188C151.932 184.09 154.405 182.271 153.71 176.432C153.014 170.593 155.718 165.392 156.205 157.826Z",
    fill: "#721011"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_f_6263_1301)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.5347 127.608C34.1758 125.577 36.5347 118.372 40.7385 115.889C45.7934 115.889 63.9086 136.06 59.8366 136.595C55.7646 137.129 51.9188 136.151 48.6893 132.276C45.4598 128.401 39.4834 130.147 36.5347 127.608Z",
    fill: "#881615"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_f_6263_1301)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.5086 150.22C62.5071 144.011 57.8528 137.064 59.0841 134.271C92.1699 129.093 158.41 121.072 160.209 133.499C162.008 145.927 113.579 158.423 84.5086 150.22Z",
    fill: "#6C1A19"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_i_6263_1301)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.4482 27.0918C45.0911 23.9478 57.3059 15.0106 63.333 10.935C122.8 -14.8285 164.729 12.7306 168.606 14.8651C173.345 17.4743 171.419 27.0918 183.473 31.4585C195.527 35.8252 197.536 49.7986 201.152 62.8987C204.769 75.9988 197.938 116.609 158.561 139.316C119.184 162.023 68.9583 146.303 60.1185 139.316C51.2788 132.329 29.1795 114.862 22.7506 87.3522C16.3217 59.842 28.7777 41.0653 31.1886 39.3186C33.5994 37.5719 43.6445 31.0219 44.4482 27.0918Z",
    fill: "#6ADEDF"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_6263_1301",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 0,
    width: 182,
    height: 152
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4482 27.0918C45.0911 23.9478 57.3059 15.0106 63.333 10.935C122.8 -14.8285 164.729 12.7306 168.606 14.8651C173.345 17.4743 171.419 27.0918 183.473 31.4585C195.527 35.8252 197.536 49.7986 201.152 62.8987C204.769 75.9988 197.938 116.609 158.561 139.316C119.184 162.023 68.9583 146.303 60.1185 139.316C51.2788 132.329 29.1795 114.862 22.7506 87.3522C16.3217 59.842 28.7777 41.0653 31.1886 39.3186C33.5994 37.5719 43.6445 31.0219 44.4482 27.0918Z",
    fill: "#6ADEDF"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_6263_1301)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_f_6263_1301)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.0041 111.076C29.0355 107.343 47.9074 136.757 50.9732 139.109C67.4744 162.334 150.469 150.19 156.691 148.72C161.668 147.544 201.951 97.0754 189.562 105.285C147.493 133.163 47.5966 121.289 34.0041 111.076Z",
    fill: "url(#paint0_linear_6263_1301)"
  }))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter16_ddddddiiii_6263_1301)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.481 49.6217C45.1714 36.6808 55.3641 33.0138 59.396 31.3838C79.8028 23.1337 159.925 15.7356 180.484 39.0098C196.143 56.737 190.965 88.7257 171.429 100.521C151.893 112.316 78.3056 112.839 54.2129 105.576C35.0821 99.8087 27.8681 65.7978 37.481 49.6217Z",
    fill: "#D3312F"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter17_ddiii_6263_1301)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 66.0198,
    cy: 74.8286,
    rx: 19.3184,
    ry: 20.9946,
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter18_i_6263_1301)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 6.60365,
    ry: 6.37029,
    transform: "matrix(0.230258 0.973536 -0.957337 0.290607 66.0197 74.829)",
    fill: "#292929"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter19_f_6263_1301)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 2.83977,
    ry: 0.819896,
    transform: "matrix(0.771563 0.603816 -0.566372 0.848793 69.9166 77.4907)",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter20_f_6263_1301)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 1.97568,
    ry: 0.432364,
    transform: "matrix(0.771342 0.604105 -0.566073 0.848995 70.1212 78.0801)",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter21_ddiii_6263_1301)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 158.951,
    cy: 74.8286,
    rx: 19.3184,
    ry: 20.9946,
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter22_i_6263_1301)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 6.60365,
    ry: 6.37028,
    transform: "matrix(0.230258 0.973536 -0.957337 0.290608 158.951 74.829)",
    fill: "#292929"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter23_f_6263_1301)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 2.83977,
    ry: 0.819897,
    transform: "matrix(0.771564 0.603814 -0.566374 0.848793 162.848 77.4907)",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter24_f_6263_1301)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 1.97568,
    ry: 0.432363,
    transform: "matrix(0.771341 0.604106 -0.566072 0.848996 163.053 78.0801)",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter25_di_6263_1301)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.6491 51.1316C46.8594 48.9087 50.3414 47.5857 52.1941 47.0454C56.5619 45.7719 66.5785 42.7958 71.1806 40.7118C76.9334 38.1069 76.7736 40.7118 73.8972 43.3168C71.0208 45.9217 50.8863 53.9102 48.6491 51.1316Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.136 40.9401C150.281 39.7998 155.055 41.7895 157.39 42.9085C159.724 44.0275 174.534 48.5855 174.772 52.473C175.011 56.3605 162.371 50.918 156.529 48.5855C150.686 46.253 147.705 42.3655 149.136 40.9401Z",
    fill: "#222222"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter26_ii_6263_1301)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M183.349 215.314C187.856 197.901 168.814 165.28 158.73 151.146C156.922 167.17 156.431 192.197 152.679 211.006C150.818 220.338 155.531 219.623 157.269 218.035C157.061 220.756 177.716 237.082 183.349 215.314Z",
    fill: "#D3312F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_6263_1301",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 152,
    y: 151,
    width: 33,
    height: 76
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M183.349 215.314C187.855 197.901 168.814 165.28 158.729 151.146C156.921 167.17 156.78 186.754 152.679 211.006C151.107 220.299 155.53 219.623 157.269 218.035C157.06 220.756 177.716 237.082 183.349 215.314Z",
    fill: "#D3312F"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_6263_1301)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter27_i_6263_1301)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.769 216.385C169.082 216.98 168.325 211.736 171.251 211.736C175.275 211.736 174.027 217.645 182.282 216.385C185.18 215.942 184.083 220.055 182.282 229.107C180.481 238.16 163.146 228.373 159.769 225.193C156.392 222.012 155.942 216.14 159.769 216.385Z",
    fill: "#E28C52"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter28_f_6263_1301)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.774 165.46C157.274 150.625 154.93 151.891 153.82 154.379C152.689 155.845 146.329 207.07 147.578 211.593C148.826 216.116 162.768 214.533 161.519 210.236C160.271 205.939 158.398 184.004 157.774 165.46Z",
    fill: "#981C1D"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter29_f_6263_1301)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.292 168.171C161.185 164.694 159.825 155.614 159.159 151.509C153.256 146.646 148.281 208.373 151.813 213.15C155.909 218.688 160.328 215.057 159.25 213.15C157.658 210.332 161.425 172.518 161.292 168.171Z",
    fill: "#9F0F0E"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter30_f_6263_1301)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.848 168.072C158.693 165.88 158.008 161.961 157.685 160.275C155.81 176.711 152.101 209.813 152.256 210.74C152.45 211.899 154.679 208.527 154.873 205.893C155.067 203.26 156.909 198.519 156.812 196.517C156.715 194.515 156.715 186.298 157.685 184.401C158.654 182.505 159.042 170.811 158.848 168.072Z",
    fill: "#801616"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_6263_1301",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 138,
    y: 145,
    width: 31,
    height: 36
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M158.841 151.327C158.816 151.041 158.585 147.331 158.473 145.512C125.551 145.512 140.273 165.187 152.115 176.71C163.958 188.233 169.339 170.51 168.65 167.517C167.962 164.524 158.872 151.685 158.841 151.327Z",
    fill: "#C4C4C4"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_6263_1301)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter31_f_6263_1301)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.611 150.905C160.653 150.905 162.086 150.47 161.974 148.65C148.659 144.651 145.234 160.115 157.077 171.638C168.92 183.162 164.816 162.524 164.128 159.531C163.439 156.538 167.094 150.905 163.611 150.905Z",
    fill: "#CB2D2B"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_6263_1301",
    x: 0.889893,
    y: 220.617,
    width: 209.137,
    height: 61.3828,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13,
    result: "effect1_foregroundBlur_6263_1301"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_6263_1301",
    x: 58.2043,
    y: 235.949,
    width: 98.7119,
    height: 25.5137,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_6263_1301"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_6263_1301",
    x: 69.8008,
    y: 238.289,
    width: 36.0828,
    height: 15.8926,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_6263_1301"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_6263_1301",
    x: 116.213,
    y: 237.727,
    width: 34.9082,
    height: 16.9531,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_6263_1301"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_ii_6263_1301",
    x: 13,
    y: 72.5508,
    width: 168.951,
    height: 176.695,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 23,
    dy: -17
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.691667 0 0 0 0 0.106632 0 0 0 0 0.119213 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_6263_1301"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.875 0 0 0 0 0.875 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_6263_1301",
    result: "effect2_innerShadow_6263_1301"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_6263_1301",
    x: 60.1104,
    y: 226.881,
    width: 98.7522,
    height: 29.0195,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    result: "effect1_foregroundBlur_6263_1301"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_6263_1301",
    x: 44.4341,
    y: 146.422,
    width: 33.5479,
    height: 28.3086,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_6263_1301"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_6263_1301",
    x: 52.1973,
    y: 153.668,
    width: 16.9558,
    height: 14.1191,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_6263_1301"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_6263_1301",
    x: 36.5376,
    y: 119.68,
    width: 138.05,
    height: 55.0059,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect1_foregroundBlur_6263_1301"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_f_6263_1301",
    x: 33.9851,
    y: 115.445,
    width: 128.684,
    height: 49.6562,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_6263_1301"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_f_6263_1301",
    x: 127.551,
    y: 138.402,
    width: 43.198,
    height: 98.5762,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "effect1_foregroundBlur_6263_1301"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_f_6263_1301",
    x: 141.417,
    y: 143.217,
    width: 28.0652,
    height: 82.7383,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    result: "effect1_foregroundBlur_6263_1301"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_f_6263_1301",
    x: 27.5991,
    y: 107.889,
    width: 40.8286,
    height: 36.8398,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_6263_1301"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_f_6263_1301",
    x: 53.9023,
    y: 121.908,
    width: 111.356,
    height: 35.9414,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_6263_1301"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_i_6263_1301",
    x: 20.928,
    y: -9,
    width: 181.072,
    height: 160.146,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -9
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_6263_1301"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_f_6263_1301",
    x: 27.1755,
    y: 98.3828,
    width: 170.742,
    height: 60.8164,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur_6263_1301"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_ddddddiiii_6263_1301",
    x: 17.24,
    y: 3.375,
    width: 184.448,
    height: 125.975,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 13
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.558333 0 0 0 0 0.996225 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6263_1301"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 7,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_6263_1301",
    result: "effect2_dropShadow_6263_1301"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.556863 0 0 0 0 0.992157 0 0 0 0 0.996078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_6263_1301",
    result: "effect3_dropShadow_6263_1301"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.45 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_6263_1301",
    result: "effect4_dropShadow_6263_1301"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.509688 0 0 0 0 0.966788 0 0 0 0 0.970833 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_dropShadow_6263_1301",
    result: "effect5_dropShadow_6263_1301"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect5_dropShadow_6263_1301",
    result: "effect6_dropShadow_6263_1301"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect6_dropShadow_6263_1301",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 9,
    dy: -13
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.533333 0 0 0 0 0.121569 0 0 0 0 0.117647 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect7_innerShadow_6263_1301"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.220833 0 0 0 0 0.0377257 0 0 0 0 0.0377257 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect7_innerShadow_6263_1301",
    result: "effect8_innerShadow_6263_1301"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3,
    dy: -6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.370833 0 0 0 0 0.088671 0 0 0 0 0.0849826 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect8_innerShadow_6263_1301",
    result: "effect9_innerShadow_6263_1301"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.383333 0 0 0 0 0.0754965 0 0 0 0 0.071875 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect9_innerShadow_6263_1301",
    result: "effect10_innerShadow_6263_1301"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_ddiii_6263_1301",
    x: 32.7014,
    y: 46.834,
    width: 64.3796,
    height: 62.9883,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.333333 0 0 0 0 0.0680555 0 0 0 0 0.106641 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6263_1301"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.270833 0 0 0 0 0.0226313 0 0 0 0 0.019184 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_6263_1301",
    result: "effect2_dropShadow_6263_1301"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_6263_1301",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 11.7428
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.54025
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.591667 0 0 0 0 0.463472 0 0 0 0 0.499527 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_6263_1301"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.13506
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.13506
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_innerShadow_6263_1301",
    result: "effect4_innerShadow_6263_1301"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.566667 0 0 0 0 0.122778 0 0 0 0 0.122778 0 0 0 0.26 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_innerShadow_6263_1301",
    result: "effect5_innerShadow_6263_1301"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter18_i_6263_1301",
    x: 58.6654,
    y: 68.1367,
    width: 13.641,
    height: 14.4523,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.06753,
    dy: 1.06753
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.06753
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_6263_1301"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter19_f_6263_1301",
    x: 62.3389,
    y: 70.303,
    width: 15.1555,
    height: 14.3765,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.66883,
    result: "effect1_foregroundBlur_6263_1301"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter20_f_6263_1301",
    x: 67.5101,
    y: 75.7645,
    width: 5.22222,
    height: 4.63311,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.533766,
    result: "effect1_foregroundBlur_6263_1301"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter21_ddiii_6263_1301",
    x: 125.633,
    y: 46.834,
    width: 64.3796,
    height: 62.9883,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.333333 0 0 0 0 0.0680555 0 0 0 0 0.106641 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6263_1301"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.270833 0 0 0 0 0.0226313 0 0 0 0 0.019184 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_6263_1301",
    result: "effect2_dropShadow_6263_1301"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_6263_1301",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 11.7428
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.54025
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.591667 0 0 0 0 0.463472 0 0 0 0 0.499527 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_6263_1301"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.13506
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.13506
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_innerShadow_6263_1301",
    result: "effect4_innerShadow_6263_1301"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.566667 0 0 0 0 0.122778 0 0 0 0 0.122778 0 0 0 0.26 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_innerShadow_6263_1301",
    result: "effect5_innerShadow_6263_1301"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter22_i_6263_1301",
    x: 151.597,
    y: 68.1367,
    width: 13.641,
    height: 14.4523,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.06753,
    dy: 1.06753
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.06753
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_6263_1301"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter23_f_6263_1301",
    x: 155.27,
    y: 70.303,
    width: 15.1555,
    height: 14.3765,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.66883,
    result: "effect1_foregroundBlur_6263_1301"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter24_f_6263_1301",
    x: 160.442,
    y: 75.7645,
    width: 5.22222,
    height: 4.63311,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.533766,
    result: "effect1_foregroundBlur_6263_1301"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter25_di_6263_1301",
    x: 46.1523,
    y: 39.6328,
    width: 128.623,
    height: 16.2012,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.429167 0 0 0 0 0.0779375 0 0 0 0 0.073316 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6263_1301"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6263_1301",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.28 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_6263_1301"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter26_ii_6263_1301",
    x: 149.251,
    y: 134.146,
    width: 57.7761,
    height: 95.3203,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 23,
    dy: -17
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.691667 0 0 0 0 0.106632 0 0 0 0 0.119213 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_6263_1301"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.875 0 0 0 0 0.875 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_6263_1301",
    result: "effect2_innerShadow_6263_1301"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter27_i_6263_1301",
    x: 157.065,
    y: 201.736,
    width: 32.0027,
    height: 31.1191,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: -10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.7875 0 0 0 0 0.3738 0 0 0 0 0.141094 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_6263_1301"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter28_f_6263_1301",
    x: 131.416,
    y: 136.85,
    width: 46.1824,
    height: 93.4629,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "effect1_foregroundBlur_6263_1301"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter29_f_6263_1301",
    x: 146.634,
    y: 147.236,
    width: 18.6614,
    height: 72.8555,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_6263_1301"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter30_f_6263_1301",
    x: 148.251,
    y: 156.275,
    width: 14.6453,
    height: 58.6992,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_6263_1301"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter31_f_6263_1301",
    x: 139.836,
    y: 138.006,
    width: 35.5349,
    height: 47.0996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect1_foregroundBlur_6263_1301"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6263_1301",
    x1: 109.423,
    y1: 126.789,
    x2: 109.423,
    y2: 151.367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#369495"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#369495",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOps);
export default __webpack_public_path__ + "static/media/ops.cfe3f856c65db49f4061708f0882d192.svg";
export { ForwardRef as ReactComponent };